import { NavbarMenu } from '@/partials/menu/NavbarMenu';

interface PageMenuProps {
    setActivePage: (page: string) => void; // Define prop type
}

const PageMenu = ({ setActivePage }: PageMenuProps) => {
    const menuItems = [
        { title: 'Overview', id: 'overview', onClick: () => setActivePage('overview') },
        { title: 'Matched Candidates', id: 'candidates', onClick: () => setActivePage('candidates') }
    ];

    return <NavbarMenu items={menuItems} />;
};

export { PageMenu };
